import { ArrowLeft } from 'lucide-react'
import reinzLogo from '@/assets/reinz-logo.svg'

interface PublicHeaderProps {
  title?: string
  onBackToRoleSelection: () => void
}

export function PublicHeader({ title, onBackToRoleSelection }: PublicHeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-card/95 backdrop-blur-xs border-b border-border safe-top">
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3">
          <button
            onClick={onBackToRoleSelection}
            className="p-1 -ml-1 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Back to start"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <img src={reinzLogo} alt="REINZ" className="h-8 w-auto" />
          {title && <span className="text-lg font-semibold text-foreground">{title}</span>}
        </div>
      </div>
    </header>
  )
}
